import { MARKETPLACE_TIERS } from '@onward-delivery/core';

export const MARKETPLACE_TIER_DISPLAYS = {
    UNKNOWN: 'Unknown',
    [MARKETPLACE_TIERS.T1_INTEGRATIONS_ONLY]: 'Tier 1 - Integrations Only',
    [MARKETPLACE_TIERS.T2_INTEGRATIONS_ONLY]: 'Tier 2 - Integrations Only',
    [MARKETPLACE_TIERS.T2_INTEGRATIONS_BILLING]: 'Tier 2 - Integrations & Billing',
    [MARKETPLACE_TIERS.T3_FULLY_MANAGED]: 'Tier 3 - Fully Managed',
};

export const defaultTiers = [
    MARKETPLACE_TIER_DISPLAYS.UNKNOWN,
    MARKETPLACE_TIER_DISPLAYS[MARKETPLACE_TIERS.T2_INTEGRATIONS_BILLING],
    MARKETPLACE_TIER_DISPLAYS[MARKETPLACE_TIERS.T3_FULLY_MANAGED],
];
